module.exports = __webpack_public_path__ + "img/mob-logo.9acd32d7.svg";